import(/* webpackMode: "eager" */ "/vercel/path0/app/parametres/page.tsx");
